import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const DrivingSection = ({ title, delay, headerClassName, imageUrl, link, buttonText }) => {
  const defaultLink = "https://511.gov.pe.ca/roadconditions?start=0&length=25&filters%5B0%5D%5Bi%5D=1&filters%5B0%5D%5Bs%5D=Kings+County&order%5Bi%5D=1&order%5Bdir%5D=asc";
  const displayButtonText = buttonText || "Check Live 511 Sensors";

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.5 }}
      className="bg-white rounded-2xl shadow-lg border border-gray-100 flex flex-col overflow-hidden"
    >
      {imageUrl && (
        <div className="w-full aspect-video overflow-hidden bg-slate-200">
          <img 
            src={imageUrl} 
            alt={title} 
            className="w-full h-full object-contain transition-transform duration-700 hover:scale-105" 
          />
        </div>
      )}
      <div className={`p-6 ${headerClassName}`}>
        <div className="flex justify-between items-start">
          <div>
            <h2 className="text-2xl font-black">{title}</h2>
            <p className="text-sm font-bold opacity-90 mt-1 uppercase tracking-wider">
              Live Sensor Data
            </p>
          </div>
          <div className="p-2 rounded-full bg-white/20 backdrop-blur-sm">
            <SafeIcon name="Truck" className="text-xl text-white" />
          </div>
        </div>
      </div>
      <div className="p-8">
        <div className="flex flex-col gap-4">
          <a 
            href={link || defaultLink} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="flex items-center justify-center gap-3 w-full py-6 px-6 bg-blue-600 hover:bg-blue-700 text-white rounded-2xl transition-all shadow-xl active:scale-[0.97] text-2xl font-black text-center"
          >
            <span>{displayButtonText}</span>
            <SafeIcon name="ExternalLink" className="text-lg" />
          </a>
          <p className="text-center text-slate-500 font-bold leading-relaxed px-4">
            View real-time road conditions, cameras, and sensor reports directly from PEI 511.
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default DrivingSection;